// https://developers.swym.it/docs/fetch-lists
export default async () => {
  return new Promise((resolve, reject) => {
    try {
      // Define success callback
      const onSuccess = function(lists) {
        // Successfully fetched all lists 
        // console.log("Fetched all Lists", lists);
        resolve(lists);
      };

      // Define error callback
      const onError = function(error) {
        // Error is an xhrObject
        console.log('Error while fetching all Lists', error);
        reject(error);
      };

      // Call `fetchLists` function
      window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
      });
    } catch (e) {
      console.log(e);
    }
  });
};
